<script lang="ts" setup>
import type { EditorialIrregular } from '@integration-layer/ampliance/schemas/editorial-irregular-schema.localized'
import type { EditorialIrregularProps } from '@design-system/components/Editorial/EditorialIrregular.props'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialIrregular
}>()

const data = await useComponentResponse<EditorialIrregular>(props)
</script>

<template>
  <EditorialIrregular
    v-if="data"
    v-bind="data as unknown as EditorialIrregularProps"
  />
</template>
